import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "./useAuth";
import { ROLES } from "../utils/enums";
import { showError } from "../constants/toasts";
import { Permission } from "../services/accessRole";

interface Permissions {
  label: string;
  isAdd: boolean;
  isView: boolean;
  isDelete: boolean;
  isEdit: boolean;
}

type SidebarLabels =
  | "Dashboard"
  | "Manage Employers"
  | "Manage Freelancers"
  | "Manage Categories"
  | "Manage Refunds"
  | "Manage Payments"
  | "Manage Payout"
  | "Manage Wallet"
  | "Manage Analytics"
  | "Manage Tasks"
  | "Report & Disputes"
  | "Manage Notifications"
  | "Manage Reviews"
  | "Manage CMS";

type PagePermission = "isView" | "isAdd";

const usePermission = ({
  label,
  page_permission,
}: {
  label: SidebarLabels;
  page_permission: PagePermission;
}) => {
  const userData = useAuth();
  const navigate = useNavigate();
  const [permission, setPermission] = useState<Permissions | null>();

  const checkPermission = () => {
    const permissions = userData?.accessRoleId?.permission as Permission[];
    const matchedPermission = permissions.find(
      (perm: Permissions) => perm.label === label
    );

    if (matchedPermission) {
      setPermission(matchedPermission);
    } else {
      navigate("/permission-denied", { replace: true });
    }
  };

  useEffect(() => {
    if (userData && userData?.role === ROLES.SUB_ADMIN) {
      checkPermission();
    } else {
      setPermission({
        label: "admin",
        isAdd: true,
        isView: true,
        isDelete: true,
        isEdit: true,
      });
    }
  }, [userData]);

  useEffect(() => {
    if (permission && !permission?.[page_permission]) {
      showError("Access denied");
      navigate("/permission-denied", { replace: true });
    }
  }, [permission]);

  return {
    isAdd: !!permission?.isAdd,
    isDelete: !!permission?.isDelete,
    isEdit: !!permission?.isEdit,
    isView: !!permission?.isView,
    // permission,
  };
};

export default usePermission;
